import { clsx } from "clsx";

import { subCheckmark, subCross } from "../../../designSystemIcons";

const subscriptionDetails = [
  // { title: "No Ads", subscription: ["Pro"] },
  {
    title: "SBC Solver",
    info: "Do SBCs fast with your fodder",
    subscription: ["Elite", "Ultimate"],
  },
  {
    title: "My Evolutions",
    info: "Meta Ratings and best evo paths",
    subscription: ["Elite", "Ultimate"],
  },
  {
    title: "My Club Overview",
    info: "See cards to sell for easy profit",
    subscription: ["Elite", "Ultimate"],
  },
  {
    title: "AI Squad Builder",
    info: "Find your club's best squads",
    subscription: ["Ultimate"],
  },
  {
    title: "My Recommendations",
    info: "Best squad upgrades tailored to your budget, fodder and evos",
    subscription: ["Ultimate"],
  },
];

type SubscriptionCardProps = {
  tier: "Elite" | "Pro" | "Ultimate";
  selected?: boolean;
  activeSubscription?: boolean;
  monthlyPrice: number;
  onClick: (activeSubView: "Elite" | "Pro" | "Ultimate") => void;
  mostPopular?: boolean;
  annualDiscount?: number;
  yearlyPrice?: number;
  currency?: string;
};

const SubscriptionCard = ({
  tier,
  selected,
  activeSubscription,
  monthlyPrice,
  onClick,
  mostPopular,
  annualDiscount,
  yearlyPrice,
  currency,
}: SubscriptionCardProps) => {
  return (
    <button
      onClick={() => onClick(tier as any)}
      className={clsx(
        "flex flex-col px-4 py-4 md-lg:py-8 bg-white rounded-lg w-[308px] relative will-change-transform",
        selected
          ? "outline outline-4 outline-primary-blue opacity-100 text-gray-800"
          : "opacity-90 text-light-secondary",
        selected
          ? "-translate-y-1.5"
          : "transition hover:-translate-y-1.5 duration-200",
      )}
    >
      {(mostPopular || activeSubscription) && (
        <p className="absolute top-0 text-sm touch-device:text-base font-medium text-white transform -translate-x-1/2 -translate-y-1/2 left-1/2 px-2 py-0.5 bg-primary-blue rounded">
          {activeSubscription ? "Active Plan" : "Most Popular"}
        </p>
      )}
      {annualDiscount && (
        <p
          className={clsx(
            "absolute bottom-0 text-sm touch-device:text-base font-medium text-white transform -translate-x-1/2 translate-y-1/2 left-1/2 px-2 py-0.5 rounded",
            selected ? "bg-primary-blue" : "bg-primary-washed-blue",
          )}
        >
          Save {annualDiscount}
          {currency}
        </p>
      )}
      <h3 className="mx-auto text-2xl font-semibold md-xs:text-3xl">{tier}</h3>
      <span
        className={clsx(
          "mx-auto font-medium",
          selected ? "text-gray-800" : "text-light-secondary",
          !monthlyPrice && "invisible",
        )}
      >
        <span className="text-lg font-semibold md-xs:text-xl">
          {currency}
          {monthlyPrice}
        </span>
        <span>/month</span>
      </span>
      <p
        className={clsx(
          "text-xs text-gray-500 mx-auto",
          annualDiscount ? "visible" : "invisible",
        )}
      >
        Billed as {currency}
        {yearlyPrice}/year
      </p>

      <div className="flex px-4 mt-2 md-lg:mt-4 gap-x-[15px]">
        {subCheckmark}
        <span className="text-base font-semibold md-xs:text-lg">No Ads</span>
      </div>
      <div
        className={clsx(
          "relative flex flex-col px-4 py-2 mt-2 border-2 rounded gap-y-2 md-lg:gap-y-4 w-full",
          tier === "Pro" ? "border-gray-700/50" : "border-gray-700",
        )}
      >
        <p
          className={clsx(
            "absolute top-0 right-0 font-medium py-0.5 px-1 rounded-bl-sm text-white text-sm",
            tier === "Pro" ? "bg-gray-700/50" : "bg-gray-700",
          )}
        >
          Club Import
        </p>

        {subscriptionDetails.map((content, index) => (
          <div
            key={index}
            className={clsx(
              "flex gap-x-[15px]",
              !content.subscription.includes(tier) && "opacity-60",
            )}
          >
            <div className="my-auto">
              {content.subscription.includes(tier) ? subCheckmark : subCross}
            </div>
            <div className={clsx("flex flex-col text-left")}>
              <span className="text-base font-semibold md-xs:text-lg">
                {content.title}
              </span>
              <p className={clsx("text-xs text-light-secondary")}>
                {content.info}
              </p>
            </div>
          </div>
        ))}
      </div>
    </button>
  );
};

export default SubscriptionCard;
